import React, {useContext, useState} from 'react';
import "./FilesComponent.css"
import fileImg from "../../accets/img/file.png";
import pdf from "../../accets/img/pdf.png";
import word from "../../accets/img/word.png";
import excel from "../../accets/img/excel.png";
import txt from "../../accets/img/txt.png";
import glass from "../../accets/img/glass.png";
import {Context} from "../../index";
import {downloadFile, fetchFiles} from "../../http/FileAPI";
import ModalFileErrore from "../Modal/ModalFileErrore";
import {observer} from "mobx-react-lite";


const FilesComponent = ({FileTask, oneTask}) => {

    const {fileStore} = useContext(Context)

    const [fileUp, setFileUp] = useState([])
    const [active, setActive] = useState(false)

    const addFiles = (fileUp, oneTask) => {
        const fileAr = [...fileUp]
        fileAr.forEach((file) => {
            const formData = new FormData()
            formData.append('id', oneTask.id)
            formData.append('file', file)
            fileStore.addNewFile(formData)
        })
        fetchFiles().then(data => fileStore.setFile(data))
        setFileUp([])

    }

    function downloadClickHandler(item) {
        downloadFile(item)
    }

    return (
        <>
            {FileTask.length !== 0
                &&
                <div className="priority__block__files">
                    {fileStore.file.filter(i => i.taskId === oneTask.id).map(item => {

                            if (item.type === "gif" || item.type === "png" || item.type === "jpg") {
                                return <div key={item.id} className="file__task__block">
                                    <img src={process.env.REACT_APP_API_URL + oneTask.id + '/' + item.name}
                                         alt={item.name}></img>
                                    <div className="file__name">{item.name}</div>
                                    <div className="mask">
                                        <div className="v__and__down__block">
                                            <a href={process.env.REACT_APP_API_URL + oneTask.id + '/' + item.name} target="_blank" rel="noopener noreferrer" className="v__block">
                                                <img src={glass} alt={glass}></img>
                                            </a>
                                            <hr/>
                                            <div onClick={() => downloadClickHandler(item)} className="arrow-8"></div>
                                        </div>
                                    </div>
                                </div>
                            } else if (item.type === "pdf") {
                                return <div key={item.id} className="file__task__block">
                                    <img src={pdf} alt={item.name}></img>
                                    <div className="file__name">{item.name}</div>
                                    <div className="mask">
                                        <div className="v__and__down__block">
                                            <a href={process.env.REACT_APP_API_URL + oneTask.id + '/' + item.name} target="_blank" rel="noopener noreferrer" className="v__block">
                                                <img src={glass} alt={glass}></img>
                                            </a>
                                            <hr/>
                                            <div onClick={() => downloadClickHandler(item)} className="arrow-8"></div>
                                        </div>
                                    </div>
                                </div>
                            } else if (item.type === "doc" || item.type === "docx") {
                                return <div key={item.id} className="file__task__block">
                                    <img src={word} alt={item.name}></img>
                                    <div className="file__name">{item.name}</div>
                                    <div className="mask">
                                        <div className="v__and__down__block">
                                            <a href={process.env.REACT_APP_API_URL + oneTask.id + '/' + item.name} target="_blank" rel="noopener noreferrer" className="v__block">
                                                <img src={glass} alt={glass}></img>
                                            </a>
                                            <hr/>
                                            <div onClick={() => downloadClickHandler(item)} className="arrow-8"></div>
                                        </div>
                                    </div>
                                </div>
                            } else if (item.type === "xls" || item.type === "xlsx") {
                                return <div key={item.id} className="file__task__block">
                                    <img src={excel} alt={item.name}></img>
                                    <div className="file__name">{item.name}</div>
                                    <div className="mask">
                                        <div className="v__and__down__block">
                                            <a href={process.env.REACT_APP_API_URL + oneTask.id + '/' + item.name} target="_blank" rel="noopener noreferrer" className="v__block">
                                                <img src={glass} alt={glass}></img>
                                            </a>
                                            <hr/>
                                            <div onClick={() => downloadClickHandler(item)} className="arrow-8"></div>
                                        </div>
                                    </div>
                                </div>
                            } else if (item.type === "txt") {
                                return <div key={item.id} className="file__task__block">
                                    <img src={txt} alt={item.name}></img>
                                    <div className="file__name">{item.name}</div>
                                    <div className="mask">
                                        <div className="v__and__down__block">
                                            <a href={process.env.REACT_APP_API_URL + oneTask.id + '/' + item.name} target="_blank" rel="noopener noreferrer" className="v__block">
                                                <img src={glass} alt={glass}></img>
                                            </a>
                                            <hr/>
                                            <div onClick={() => downloadClickHandler(item)} className="arrow-8"></div>
                                        </div>
                                    </div>
                                </div>
                            } else {
                                return <div key={item.id} className="file__task__block">
                                    <img src={fileImg} alt={item.name}></img>
                                    <div className="file__name">{item.name}</div>
                                    <div className="mask">
                                        <div className="v__and__down__block">
                                            <hr/>
                                            <div onClick={() => downloadClickHandler(item)} className="arrow-8"></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        }
                    )}
                </div>
            }

            <div className="priority__block">
                <div className="name__cat">Прикрепить</div>
                <div className="input-file-row">
                    <label className="input-file">
                        <input onChange={e => setFileUp(e.target.files)} type="file" multiple
                               accept="*"></input>
                    </label>
                    <div className="input-file-list"></div>
                </div>
                <h4>Выберите файл для закрепления к задаче</h4>
                {fileUp.length
                    ?
                    <div className="up__btn__show" onClick={() => addFiles(fileUp, oneTask)}>
                        Загрузить
                    </div>
                    : null
                }

            </div>

            {fileUp.length !== 0
                &&
                <h4 className="add__file__title">Добавленные файлы к задаче:</h4>
            }

            {fileUp.length !== 0
                &&
                <div className="priority__block__files priority__block__files__add">
                    {Array.from(fileUp).map(item =>
                        <div key={item.name} className="file__task__block">
                            <img src={fileImg} alt={item.name}></img>
                            <div className="file__name">{item.name}</div>
                        </div>
                    )}
                </div>
            }
            <ModalFileErrore active={active} setActive={setActive}/>
        </>
    );
};

export default observer(FilesComponent);